import { firstValueFrom } from 'rxjs';
import { MpsUser } from '../../app/models/mps-user.model';
import { MpsPostLoginUrlHelper } from '../helpers/mps-post-login-url.helper';
import { MpsOauth2Service } from '../services/mps-oauth2.service';
import { MpsUserService } from '../services/mps-user.service';

export function mpsFetchBearer(oauth2service: MpsOauth2Service, userService: MpsUserService) {
  return (): void | Promise<MpsUser> => {
    const url = new URL(window.location.href);
    const id = url.searchParams.get('_et');

    if (id) {
      return firstValueFrom(oauth2service.fetchToken(id)).then((response: { token: string }) => {
        localStorage.setItem('token', response.token);
        return firstValueFrom(userService.fetchUser()).then((user: MpsUser) => {
          restorePostLoginUrl();
          return user;
        });
      });
    }
  };
}

/**
 * Sends the user to the page they were trying to reach before login, instead of their role home.
 *
 * Chained onto the exchange rather than registered as its own initializer: Angular invokes every
 * app initializer synchronously and only awaits the returned promises together, so a separate
 * initializer would run while this exchange was still in flight and always see a logged-out user.
 *
 * `replaceState` is enough because the router's initial navigation runs once all initializers
 * settle and reads `window.location` then — the deep link activates through the normal guard
 * pipeline, with no extra navigation and no `/oauth2/token` entry left in history.
 */
function restorePostLoginUrl(): void {
  const target = MpsPostLoginUrlHelper.consume();
  if (!target) {
    return;
  }

  window.history.replaceState(null, '', target);
}
